
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.636 8.05A1 1 0 007.05 6.636l-.707-.707A1 1 0 004.93 7.343l.707.707zm13.435-.707l-.707.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 111.414 1.414zM8 13a4 4 0 116.646 3H9.354A3.989 3.989 0 018 13zm.97 5H21a1 1 0 100-2h-3.803a6 6 0 10-10.394 0H3a1 1 0 100 2h5.97zM4 14a1 1 0 100-2H3a1 1 0 100 2h1zm18-1a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1z","fill":"#A6B7D4"}}),_c('rect',{attrs:{"x":"11","y":"3","width":"2","height":"3","rx":"1","fill":"#A6B7D4"}})])
          )
        }
      }
    